import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';
import { TmwTranslateDirective } from '@shared/directives/translate.directive';

@Component({
  standalone: true,
  templateUrl: './confirm-dialog.component.html',
  imports: [CommonModule, TmwTranslateDirective],
})
export class ConfirmDialogComponent {
  @Input() title = 'Confirmation';
  @Input() message = 'Êtes-vous certain de vouloir effectuer cette action ?';
  @Input() confirmLabel = 'Confirmer';
  @Input() confirmClass = 'btn-warning';
  @Input() icon = 'bi-question-circle-fill';
  // When true, title/message/confirmLabel are REF_TRADUCTION keys rendered via [tmwTranslate]
  // (shows the inline edit icon) instead of already-resolved display strings.
  @Input() translateKeys = false;
  @Input() translateValues?: Record<string, unknown>;

  constructor(public activeModal: NgbActiveModal) {}

  cancel(): void {
    this.activeModal.dismiss();
  }

  confirm(): void {
    this.activeModal.close('confirmed');
  }
}
